import { Modal } from 'antd';

import AntModal from './styles/modal.style';

const CustomModal = AntModal(Modal);

export default CustomModal;
